import { BaseModel } from '../../shared/entities/base.model';

export class AnswerModel extends BaseModel {
    type: AnswersTypeModel;
    text: string;
    value: string;
    values: Array<AnswerChecboxModel>;
}

export class AnswerChecboxModel extends BaseModel {
   name: string;
   text: string;
   correct: boolean = false;
}


export class AnswersTypeModel extends BaseModel {
    id: string;
    name: string;
    options: Array<any>;
}

